namespace TabAurous {
    export interface StoneBifurcationExportExcelRequest extends Serenity.ServiceRequest {
        Items?: TabAurous.Reports.StoneBifurcationRow[];
    }
}
